export default {
    formatPhone(phone) {
        if (!phone) return '';
        let cleanPhone = phone.replace('@s.whatsapp.net', '').replace(/\D/g, '');
        
        if (cleanPhone.startsWith('55')) {
            cleanPhone = cleanPhone.substring(2);
        }
        
        if (cleanPhone.length === 11) {
            return `(${cleanPhone.substring(0, 2)}) ${cleanPhone.substring(2, 7)}-${cleanPhone.substring(7)}`;
        } else if (cleanPhone.length === 10) {
            return `(${cleanPhone.substring(0, 2)}) ${cleanPhone.substring(2, 6)}-${cleanPhone.substring(6)}`;
        }
        
        return cleanPhone;
    },

    formatTime(date) {
        if (!date) return '';
        const d = new Date(date);
        const now = new Date();
        const diff = now - d;
        const minutes = Math.floor(diff / 60000);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);

        if (minutes < 1) return 'Agora';
        if (minutes < 60) return `${minutes}m`;
        if (hours < 24) return `${hours}h`;
        if (days < 7) return `${days}d`;
        
        return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    },

    formatMessageTime(date) {
        if (!date) return '';
        const d = new Date(date);
        return d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    },

    getMediaType(mimeType) {
        if (!mimeType) return 'document';
        if (mimeType.startsWith('image/')) return 'image';
        if (mimeType.startsWith('video/')) return 'video';
        if (mimeType.startsWith('audio/')) return 'audio';
        return 'document';
    },

    isImage(type) {
        return type === 'image';
    },

    isVideo(type) {
        return type === 'video';
    },

    isAudio(type) {
        return type === 'audio' || type === 'voice';
    },

    isDocument(type) {
        return type === 'document';
    },
};

